
import React from 'react';
import * as Constants from '../constants';

const Footer: React.FC = () => {
  return (
    <footer className="py-8 bg-slate-200/80 backdrop-blur-sm text-center text-slate-500 text-sm snap-start">
      {/* snap-start here is more for completeness, footer is typically not a full snap target in this way */}
      <div className="container mx-auto px-6">
        <p>{Constants.FOOTER_TEXT}</p>
      </div>
    </footer>
  );
};

export default Footer;
